const config = {
  "LifetimeContributionLimit": 50000,
  "CESGLifetimeGrantLimit": 7200,
  "SAGESLifetimeGrantLimit": 0,
  "CESGGrantPercentage": 0.2,
  "SAGESGrantPercentage": 0,
  "MaxYearlyCESGGrant": 1000,
  "MaxYearlySAGESGrant": 0,
  "QESIGrantPercentage": 0.1,
  "MaxYearlyQESIGrant": 250,
  "MaxYearlyContributionForACESGGrant": 500,
  "MaxYearlyContributionForAQESIGrant": 500,
  "InterestRateForProjections": 0.045,
  "InterestDeficiencyRate": 0.007,
  "ACESGFamilyIncomeLevel1": 58523.01,
  "ACESGFamilyIncomeLevel2": 117045.01,
  "ACESGFamilyIncomeLevel1Rate": 0.2,
  "ACESGFamilyIncomeLevel2Rate": 0.1,
  "ACESGQuebecFamilyIncomeLevel1": 53345.01,
  "ACESGQuebecFamilyIncomeLevel2": 108680.01,
  "ACESGQuebecFamilyIncomeLevel1Rate": 0.1,
  "ACESGQuebecFamilyIncomeLevel2Rate": 0.05,
  "CLBInitialAmount": 500,
  "CLBYearlyAmount": 100,
  "CLBMaximumAmount": 2000,
  "ACESInitialAmount": "0",
  "ACESOngoingAmount": "0",
  "AirMilesPer100Dollars": "950",
  "BCTESGGrantAmount": 1200,
  "QESILifetimeGrantLimit": 3600,
  "CLBIncomeThreshold": "57375"
}

export default config;